<template>
  <div class="bar-options-setting-dialog" ref="barSetting">
    <!-- <el-collapse v-model="sizeActiveNames">
      <el-collapse-item title="位置尺寸" name="1">
        <div class="content clearFloat">
          <widthAndSizeAndZindex :options="options" :ids="ids" />
        </div>
      </el-collapse-item>
    </el-collapse> -->
    <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
    <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
    <el-collapse v-model="collapseActiveNames">
      <el-collapse-item title="数据组" name="8">
        <div class="setting-item">
          <template>
            <div class="mt16">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="outerCircleRadius"
                title="刻度占比"
                titlePosition="singleLine"
                :sliderMax="100"
                suffix="%"
              />
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="innerCircleRadius"
                title="外环占比"
                titlePosition="singleLine"
                :sliderMax="100"
                suffix="%"
              />
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="innerBgRadius"
                title="外环背景占比"
                titlePosition="singleLine"
                :sliderMax="100"
                suffix="%"
              />
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="innerPieRadius"
                title="内环饼图占比"
                titlePosition="singleLine"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <gaugeSeriesSetting :options="options" :seriesData="seriesData" :ids="ids"></gaugeSeriesSetting>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import gaugeSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/gaugeSeriesSetting"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"

// 引入默认折线图样式

export default {
  name: "bar-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    gaugeSeriesSetting,
    widthAndSizeAndZindex,
    legendSetting,
    controlWidthAndSizeAndZindex
  },
  mixins: [publicData],
  props: { options: Object },
  data() {
    return {
      this1: this,
      activeNames: ["8"],
      sizeActiveNames: ["1"],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      singleColorDefault: "rgba(0, 71, 255, 1)",
      multiColorDefault: {
        startColor: "#5A81FF",
        endColor: "#4BDFFF"
      },
      collapseDataActiveNames: [],
      changeStatus: false,
      oldBarSeries: [],
      oldLineSeries: [],
      typeSelectOptions: [
        {
          label: "双向柱状图",
          value: 1
        },
        {
          label: "正负柱状图",
          value: 2
        }
      ]
    }
  },
  watch: {
    seriesData: {
      handler(newVal, oldVal) {
        if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal))) this.init()
      },
      deep: true
    }
  },
  comments: {},
  created() {
    this.init()
  },
  mounted() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series) {
          // console.log(this.options.chartOption.series)
          return this.options.chartOption.series
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption", false)
      }
    },
    showBackground: {
      get() {
        return this.options.chartOption.series[0].showBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + 0 + ".showBackground", false)
      }
    },
    backgroundStyleColor: {
      get() {
        return this.options.chartOption.series[0].backgroundStyle.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + 0 + ".backgroundStyle.color", false)
      }
    },
    showLabelUnitValue: {
      get() {
        if (this.getValueIsPercentage) {
          return "%"
        } else if (typeof this.seriesData[0].label.formatter === "string") {
          // this.checkFormatterValue()
          let formatter = this.seriesData[0].label.formatter
          const start = formatter.indexOf("valueUnit|") + 10
          let str = formatter.substring(start, formatter.length)
          const end = str.indexOf("}")
          return str.substr(0, end)
        } else {
          return ""
        }
      }
    },
    showDataName: {
      get() {
        return this.options.chartOption.isShowDataName
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.isShowDataName", false)
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        let index = pluginName.indexOf("formatterValToPercentage")
        pluginName.splice(index, 1)
        if (index > -1) {
          // this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
          pluginName.push("formatterValToPercentage")
          this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
        } else {
          let name = this.showDataName ? "\n{b|{b}}" : ""
          this.seriesData.forEach((item, index) => {
            this.$changeOptionsEV(
              "{c}{valueUnit|" + this.showLabelUnitValue + "}" + name,
              "chartOption.series." + index + ".label.formatter",
              false
            )
          })
        }
      }
    },
    getValueIsPercentage: {
      get() {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        let index = pluginName.indexOf("formatterValToPercentage")
        return index > -1 ? true : false
      },
      set(newVal) {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        if (newVal) {
          // 显示为百分比
          pluginName.includes("formatterValToPercentage") ? "" : pluginName.push("formatterValToPercentage")
        } else {
          // 显示为数值
          let index = pluginName.indexOf("formatterValToPercentage")
          pluginName.splice(index, 1)
          let name = this.showDataName ? "\n{b|{b}}" : ""
          this.seriesData.forEach((item, index) => {
            this.$changeOptionsEV("{c}{valueUnit|}" + name, "chartOption.series." + index + ".label.formatter", false)
          })
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },
    outerCircleRadius: {
      get() {
        return parseInt(this.options.chartOption.series[0].radius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.0.radius", false)
      }
    },
    innerCircleRadius: {
      get() {
        return parseInt(this.options.chartOption.series[1].radius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.1.radius", false)
      }
    },
    innerBgRadius: {
      get() {
        return parseInt(this.options.chartOption.series[2].radius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.2.radius", false)
      }
    },
    innerPieRadius: {
      get() {
        return parseInt(this.options.chartOption.series[3].radius[1])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.3.radius.1", false)
      }
    }
  },
  methods: {
    init() {
      // 图表类组件兼容以前老数据，没有seriesTempAttributes属性的数据
      if (!this.options.chartOption.seriesTempAttributes) {
        const seriesTempAttributes = {
          // 用于存放数据中的通用配置项
          coordinateType: "rectangular" //直角坐标系
        }
        this.$changeOptionsEV(seriesTempAttributes, "chartOption.seriesTempAttributes", false)
      }
      this.options.chartOption.series.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        if (val == "8") {
          return
        }
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
  }
}
</script>

<style scoped>
.inlineMiddle {
  display: inline-block;
  vertical-align: middle;
}
.width_100 {
  width: 100%;
}

.percent100 {
  width: 100%;
}

.percent68 {
  width: 68%;
}

.height32 {
  height: 32px;
  line-height: 32px;
}

.percent36 {
  width: 36%;
}

.percent38 {
  width: 38%;
}

.percent56 {
  width: 56%;
}
.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 80%;
}

.item-title-box {
  width: calc(100% - 40px);
  justify-content: space-between;
}

.bar-options-setting-dialog /deep/ .el-collapse-item__header {
  min-height: 44px;
  height: auto;
}

/* 名称和输入框中间的滑块 */
.center-slider {
  width: calc(74% - 86px);
}
</style>
<style>
.number-input-box {
  position: relative;
  display: inline-block;
}

.number-input-box .el-input-number .el-input__inner {
  padding-right: 30px;
  text-align: left;
}
.bar-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 24px;
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.bar-options-setting-dialog .tabs.home_tabs .tabs-item {
  color: rgba(0, 0, 0, 0.6);
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.percent65_ {
  width: calc(100% - 65px);
}
</style>
